import * as React from "react";
import { Box, Typography, Card, CardContent, CardActionArea, CardMedia, Paper } from '@mui/material';
import { DateTime } from 'luxon';
import { dateFormat } from "../../utils/theme";

const ArticleCard = props => {
	const { title, body, icon, link, image, date, topic } = props;
	if (!link) console.warn(`ArticleCard component requires a link prop. ${link} was provided instead.`);

	let dateString;
	if (!!date !== false) {
		const parsed = DateTime.fromISO(date);
		if (parsed.isValid)dateString = parsed.toLocaleString(dateFormat);
		else dateString = date;
	}

	return (
		<Card variant="articleCard" className="articleCard">
			<CardActionArea href={link} disableRipple={true}>
				{image && <CardMedia 
					component="img"
					height="153"
					alt={title}
					image={`${process.env.CDN_DOMAIN||''}${image}`}
				/>}
				<CardContent className={(icon) ? 'hasIcon' : ''}>
					<Box className="card__content__container">
						<Box className="card__content__container__top">
							{title && <Typography component='h3' variant={'h3__card'}>{title}</Typography>}
							{dateString && <Typography component='p' variant={'p__card__date'}>{dateString}</Typography>}
							{body && <Typography component='p' variant={'p__card'}>{body}</Typography>}
						</Box>
						{icon && <div className="roundImage" style={{backgroundImage: `url(${process.env.CDN_DOMAIN||''}${icon})`}} />}
					</Box>
					{topic && Array.isArray(topic) && 
						<Box component="div" className="card__topics__container">
						{topic.map((item,index) => (
							<Paper key={`topic__chip__${index}`} className="topic__chip" variant="label"><Box component="span" className="topic__chip__label">{item?.object?.name}</Box></Paper>
						))}
						</Box>
					}
				</CardContent>
			</CardActionArea>
		</Card>
	)
};
export default ArticleCard;